import { render, staticRenderFns } from "./PelletsChartComparison.vue?vue&type=template&id=411a07b5&scoped=true"
import script from "./PelletsChartComparison.vue?vue&type=script&lang=ts"
export * from "./PelletsChartComparison.vue?vue&type=script&lang=ts"
import style0 from "./PelletsChartComparison.vue?vue&type=style&index=0&id=411a07b5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411a07b5",
  null
  
)

export default component.exports